import {isNil} from 'ramda';

import {Nullish} from 'shared/web';

import {isUnifiedSourcingEnabled} from '../../../utils/isUnifiedSourcingEnabled';

const SAFE_PROTOCOLS = ['http:', 'https:'];

/**
 * The URL of a third-party listing, or null when it is not a plain web link. Listing URLs come
 * from scraped data, so anything else (`javascript:`, `data:`, `vbscript:`…) is never linked.
 */
export const toSafeExternalUrl = (url: string | Nullish) => {
  if (isNil(url)) {
    return null;
  }

  try {
    const parsedUrl = new URL(url);
    if (!SAFE_PROTOCOLS.includes(parsedUrl.protocol)) {
      return null;
    }
    return isUnifiedSourcingEnabled() ? parsedUrl.href : url;
  } catch {
    // Not a URL at all.
    return null;
  }
};
